import React from "react";

export default function FormConfirmation({ text }) {
    return (
        <div className="pof-confirmation">{text}</div>
    );
}
